import { Alert, Collapse } from '@mui/material'

/**
 * Displays error messages for any failed action mainly used for forms
 */
export const ErrorMessage = ({ message, alertProps = {}, ...rest }) => {
  return (
    <Collapse in={!!message} {...rest}>
      <Alert severity="error" variant="contained" {...alertProps}>
        {message}
      </Alert>
    </Collapse>
  )
}
